import { render } from "./BioRequestCard.vue?vue&type=template&id=50f9e3cf"
import script from "./BioRequestCard.vue?vue&type=script&lang=js"
export * from "./BioRequestCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__